import {AutogenLayoutMarketExprtOutputFiltersPanel} from "./autogen/AutogenLayoutMarketExprtOutputFiltersPanel";

export class MarketExprtOutputFiltersPanel extends AutogenLayoutMarketExprtOutputFiltersPanel{

    textboxOrderTypeBeforeLookupModelSearch(event) {
        event.filter.is_active = 'Y';
    }
}
